module.exports = __webpack_public_path__ + "static/media/linkedInIcon.c1513ba6.webp";